export enum SPLIT_WORKSPACES {
  zapier = "zapier",
  revenue = "revenue",
}
